import { useParams } from "@on-site/libs/router";
import { parseToString } from "@on-site/utils/parse";

export const useClinicParams = () => {
  const params = useParams();

  return {
    groupId: parseToString(params.groupId, ""),
    clinicId: parseToString(params.clinicId, ""),
  };
};
